<div class="core-ui-autocomplete" cdkOverlayOrigin #origin="cdkOverlayOrigin" #originRef>
    <core-ui-input-text-form [label]="label" [placeholder]="placeholder" [icon]="icon" [iconPosition]="iconPosition"
        [iconColor]="iconColor" [type]="type" [readOnly]="readOnly" [error]="error" [isDisabled]="disabled" [block]="block" [size]="size" [sizeIcon]="sizeIcon"
        [ariaAutocomplete]="'list'" [ariaControls]="listboxId" [ariaExpanded]="panelOpen" [ariaActiveDescendant]="activeOptionId"
        [uiMode]="uiMode" [modelValue]="displayValue" (valueChange)="onTermChange($event)" (focused)="onFocus()"
        (blurred)="onBlur()" (keyPressed)="onKeydown($event)">
    </core-ui-input-text-form>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="panelOpen"
        [cdkConnectedOverlayWidth]="overlayWidth" [cdkConnectedOverlayHasBackdrop]="false"
        [cdkConnectedOverlayScrollStrategy]="scrollStrategy" [cdkConnectedOverlayPositions]="positions"
        (detach)="onOverlayDetach()">
        <div class="core-ui-autocomplete__dropdown" #panelEl [id]="listboxId" role="listbox" (mousedown)="onPanelMouseDown()">

            <div class="core-ui-autocomplete__state" *ngIf="showMinCharsHint">
                Escribe al menos {{ minChars }} caracteres para buscar.
            </div>

            <div class="core-ui-autocomplete__state" *ngIf="loading">Buscando…</div>

            <div class="core-ui-autocomplete__state" *ngIf="showNoResults">
                No se encontraron resultados.
            </div>

            <button *ngFor="let item of results; let i = index; trackBy: trackByFn" #optionEl type="button" role="option"
                [id]="getOptionId(i)"
                [attr.aria-selected]="isSelected(item)"
                class="core-ui-autocomplete__option"
                [ngClass]="{
                    'core-ui-autocomplete__option--active': i === activeIndex,
                    'core-ui-autocomplete__option--selected': isSelected(item)
                }"
                (mouseenter)="onOptionMouseEnter(i)"
                (click)="selectItem(item)">
                {{ displayWith(item) }}
            </button>

        </div>
    </ng-template>
</div>
